import * as S from "./SwitchButton.style";

interface SwitchButtonProps {
  id?: string;
  value: boolean;
  onClick: any;
  loginType?: string;
}

export const SwitchButton = ({ id, value, onClick }: SwitchButtonProps) => {
  const handleClick = async () => {
    if (!id) return;
    onClick();
  };

  return (
    <S.SwitchButton onClick={handleClick}>
      <S.SwitchIndicator $value={value}>
        <S.SwitchToggle $value={value} />
        <S.Label $value={value}>{value === true ? "켜짐" : "꺼짐"}</S.Label>
      </S.SwitchIndicator>
    </S.SwitchButton>
  );
};
